import PropTypes from 'prop-types'

// A question's answer payload, or one of the two sentinels the page hands a block in its place: 'loading'
// while the answer is still being calculated, and 'loaded' for an Xpert question whose generated questions
// came back (their answers are drawn by those questions). One contract for every question type.
export const answerPropType = PropTypes.oneOfType([PropTypes.oneOf(['loading', 'loaded']), PropTypes.object])
